import * as React from "react";
import { CreateOrEditReleasePage } from "./CreateOrEditReleasePage";
interface EditReleasePageProps {
    releaseVersion: string;
}
export function EditReleasePage({ releaseVersion }: EditReleasePageProps) {
    return <CreateOrEditReleasePage releaseVersion={releaseVersion}/>;
}
